// extracted by mini-css-extract-plugin
export default {"price":"Dja-z","onSale":"Eja-z","msrpLabelPrice":"Fja-z","msrpLabel":"Gja-z","originalPrice":"Hja-z"};